export default axios => ({
  confirm(ids) {
    return axios.post('ml-service/confirm-recognition-history-marks', {marks: ids});
  },
  deny(ids) {
    return axios.post('ml-service/deny-recognition-history-marks', {marks: ids});
  }
});

